import React, {useState} from 'react';

const MenuFooter = ({  }) => {

  const [expanded, setExpanded] = useState(false);
  const alertText = '*자세한상담은 계약 초기생성된 단톡방으로 문의부탁드립니다.';

  return (
    <div className="report-button fixed">
        <button className="report-btn">
            <span className="alert-icon"><p>공지</p></span>
            {/* <span className={expanded ? "alert-full-text" : "alert-one-line-text"} onClick={() => setExpanded(!expanded)}>{alertText}</span> */}
            <span className="alert-text">{alertText}</span>
        </button>
    </div>
  );
};

export default MenuFooter;